import { createRoute, lazyRouteComponent } from "@tanstack/react-router";

const InvoicesPage = lazyRouteComponent(() => import("@modules/invoices/pages/InvoicesPage"), "InvoicesPage");

export function getRoutes(parentRoute) {
  return [createRoute({ getParentRoute: () => parentRoute, path: "/invoices", component: InvoicesPage })];
}
